// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11aRO","content":"styles_content__3mGmh","row":"styles_row__fgzFF","footer":"styles_footer__2yvlA","phraseLength":"styles_phraseLength__3Y-mA"};